import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';
import { Fancybox } from '@fancyapps/ui';

domReady(() => {
  const galleryImages = document.querySelectorAll(
    '.woocommerce-product-gallery__image a'
  );
  const productCarouselBlocks = document.querySelectorAll('.related-products');

  if (0 < galleryImages.length) {
    Fancybox.bind('.woocommerce-product-gallery__image a', {
      groupAll: true,
    });
  }

  if (0 < productCarouselBlocks.length) {
    productCarouselBlocks.forEach((productCarouselBlock) => {
      new Swiper(
        productCarouselBlock.querySelector('.related-products__carousel'),
        {
          // Optional parameters
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 20,
          scrollbar: {
            el: productCarouselBlock.querySelector('.swiper-scrollbar'),
          },
          navigation: {
            nextEl: productCarouselBlock.querySelector('.swiper-button-next'),
            prevEl: productCarouselBlock.querySelector('.swiper-button-prev'),
          },
          a11y: {
            prevSlideMessage: _x(
              'Go to previous slide',
              'swiper accessibility',
              'vtx'
            ),
            nextSlideMessage: _x(
              'Go to next slide',
              'swiper accessibility',
              'vtx'
            ),
          },
        }
      );
    });
  }
});
